import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DataEntity} from "octopus-connect";
import {Actuality} from "fuse-core/components/home-page/home-page.service";
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-actuality-card',
  standalone: true,
    imports: [
        MatIconModule,
        TranslateModule
    ],
  templateUrl: './actuality-card.component.html',
  styleUrl: './actuality-card.component.scss'
})
export class ActualityCardComponent {
    @Input() isActualityWithCollectivity: boolean;
    @Input() actuality: DataEntity<Actuality>;
    @Output() actionEmitter: EventEmitter<boolean> = new EventEmitter();

    action() {
        this.actionEmitter.next(true);
    }
}
